import React from 'react'
import { Link } from 'react-router-dom'
import { Text } from '@planningcenter/tapestry-react'

import sorter from '~/utils/subscription_sorter.js'
import get from '~/utils/paginated.js'
import Loading from '~/webhooks/components/loading.jsx'
import Error from '~/webhooks/components/error.jsx'
import Subscriptions from '~/webhooks/components/subscriptions.jsx'
import { PageHeader } from '~/components/tapestry'

class Index extends React.Component {
  state = {
    subscriptions: {},
    isLoading: true,
    error: null,
  }

  componentDidMount() {
    get('/webhooks/v2/subscriptions')
      .then((results) => {
        this.setState({
          isLoading: false,
          subscriptions: sorter({}, results),
        })
      })
      .catch((error) => {
        this.setState({ error: error.message })
      })
  }

  render() {
    const { error, isLoading, subscriptions } = this.state
    const keys = Object.keys(subscriptions)
    return (
      <Error error={error}>
        <Loading isLoading={isLoading}>
          <PageHeader
            actions={
              <Link
                to="/subscriptions/new"
                className="tds-btn tds-btn--interaction"
              >
                Add
              </Link>
            }
            subtitle={
              <Text>
                Webhooks are created under your specific user account (they only
                return data you have permission to see within Planning Center).
              </Text>
            }
          >
            <h1>Webhooks</h1>
          </PageHeader>

          <div className="main-body">
            <div className="main-content w-100% xw-960p mx-a">
              {keys.length === 0 ? (
                <BlankState />
              ) : (
                keys.map((key, index) => {
                  return (
                    <Subscriptions
                      key={key}
                      url={key}
                      isLast={keys.length - 1 === index}
                      subscriptions={subscriptions[key]}
                    />
                  )
                })
              )}
            </div>
          </div>
        </Loading>
      </Error>
    )
  }
}

const BlankState = () => (
  <div class="pane">
    <div class="pane__body">
      <div class="pane__empty">
        <p>A webhook provides your application with real-time information.</p>
        <Link
          className="tds-btn tds-btn--outline-interaction mt-2"
          to="/subscriptions/new"
        >
          Add A New Subscription URL
        </Link>
      </div>
    </div>
  </div>
)

export default Index
